import { render } from "./PersonalRemove.vue?vue&type=template&id=0813980f"
import script from "./PersonalRemove.vue?vue&type=script&lang=js"
export * from "./PersonalRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__